import { render } from "./Collapsible.vue?vue&type=template&id=4f84994c&scoped=true"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"

import "./Collapsible.vue?vue&type=style&index=0&id=4f84994c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f84994c"]])

export default __exports__